<template>
    <div>
        <vueper-slides class="no-shadow" :visible-slides="3" slide-multiple :slide-ratio="1/3" :dragging-distance="400"
                       :breakpoints="{ 800: { visibleSlides: 1 }}">
            <vueper-slide v-for="item in data" :key="item.id">
                <div slot="slideContent">
                    <div class="item-box-blog-image">
                        <div class="item-box-blog-date bg-blue-ui white"><span class="mon">{{item.date}}</span></div>
                    </div>
                    <b-card
                            img-alt="Image"
                            img-height="168"
                            img-top
                            tag="article"
                            class="mb-2 news_card"
                    >
                        <router-link :to="'/news/'+item.id">
                            <b-card-img :src="(item.image) ? '/static/uploads/'+item.image: '/static/images/no_image.jpg'" class="card-img-top"/>
                        </router-link>
                        <b-card-text>
                            <router-link :to="'/news/'+item.id">
                            <p class="font-weight-bold mb-1" style="min-height: 50px">
                                {{ func_substring(item['title_' + selectedLocale.suffix.toLowerCase()], 40) }}</p>
                            </router-link>
                            <!--                            <small>{{ item.name }}</small>-->
                            <hr/>
                            <div class="item-box-blog-text" style="min-height: 100px">
                                <div class="mb-0"
                                     v-html="func_substring(item['body_'+selectedLocale.suffix.toLowerCase()], 100)"></div>
                                <!--<p class="mb-0"> {{ func_substring(item['body_'+selectedLocale.suffix.toLowerCase()],100 )}}</p>-->
                            </div>
                        </b-card-text>
                    </b-card>
                </div>
            </vueper-slide>
        </vueper-slides>
        <!--<b-modal id="modal-tall" centered size="lg" scrollable hide-footer ref="news_info">
            <template v-slot:modal-header="{ close }">
                <h5 style="color: black">{{$t('message.news')}}</h5>
                <b-button size="sm" variant="outline-danger" @click="close()">
                    <i class="fas fa-close"></i>
                </b-button>
            </template>
            <div class="text-center full">
                <b-img :src="(selected_news.image) ? '/static/uploads/'+selected_news.image: '/static/images/no_image.jpg'"
                       class="image_news text-center" fluid alt="Responsive image"></b-img>

            </div>
            <h1 class="text-center">{{selected_news['title_' + selectedLocale.suffix.toLowerCase()]}}</h1>

            <div class="h-75  d-inline-block text-justify">
                <div class="my-4" v-html="selected_news['body_'+selectedLocale.suffix.toLowerCase()]"></div>
            </div>
        </b-modal>-->
    </div>
</template>

<script>
    import {VueperSlides, VueperSlide} from 'vueperslides'
    import 'vueperslides/dist/vueperslides.css'
    import {
        mapGetters
    } from "vuex";

    export default {
        props: ['data'],
        components: {VueperSlides, VueperSlide},
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        data() {
            return {
                selected_news: {}
            }
        },
        methods: {
           /* openNews(val) {
                this.$refs.news_info.show()
                this.selected_news = val
            },*/
            func_substring(val, count) {
                return (val.length > count) ? val.substring(0, count) + '...' : val
            }
        }
    }
</script>

<style>
    .vueperslides {
        padding-top: 15px;
    }

    .vueperslide__content-wrapper {
        width: 90% !important;
        padding-top: 35px;
    }

    @media only screen and (max-width: 1000px) and (min-width: 490px) {
        .vueperslides__parallax-wrapper {
            padding-bottom: 55% !important;
        }
    }

    @media only screen and (max-width: 490px) {
        .vueperslides__parallax-wrapper {
            padding-bottom: 160% !important;
        }
    }

    @media only screen and (min-width: 490px) {
        .vueperslides__parallax-wrapper {
            padding-bottom: 40.6666% !important;
        }
    }
    @media only screen and (max-width: 320px) {
        .vueperslides__parallax-wrapper {
            padding-bottom: 200% !important;
        }
    }

    .vueperslides__bullets--outside .vueperslides__bullet--active {
        background-color: #42b983 !important;
        border: 1px solid #42b983;
    }

    .item-box-blog-text {
        max-height: 100px;
        overflow: hidden;
    }

    .item-box-blog-date {
        position: absolute;
        z-index: 5;
        padding: 10px 20px;
        top: -20px;
        right: 8px;
        background-color: #708198 !important;
    }

    .item-box-blog-date span {
        color: #fff;
        display: block;
        text-align: center;
        line-height: 1.2;
    }

    .item-box-blog-date span.mon {
        font-size: 18px;
    }

    .item-box-blog-date span.day {
        font-size: 16px;
    }

    .item-box-blog-image {
        position: relative;
    }

    .item-box-blog-image figure img {
        width: 100%;
        height: auto;
    }

    .image_news {
        height: 280px;
        width: 100%;
    }

    @media (max-width: 768px) and (min-width: 490px) {
        .index_object {
            font-size: 1rem;
        }
        .vueperslides__parallax-wrapper {
            padding-bottom: 110% !important;
        }
    }
.news_card .card-body{
    padding: 0;
}.news_card .card-body .card-text{
     padding: 1.25rem;
}
</style>
